module.exports = __webpack_public_path__ + "static/cred_27001.e2e8ccff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer/cred_27001.png
// module id = 1405
// module chunks = 168707334958949